export default {
  title: "Pop Entry/Exit"
  , form: {
    descripcion: {
      label: "Descripción"
      , th: "Descripción"
    }
    , tipo: {
      label: "Tipo"
      , th: "Tipo"
    }
    , defaults: { label: "Valor Default" }
    , multiple: { label: "Pop Entry Acepta Multiples" }
  }
  , errors: {
    BD5013: { text: "Ocurrió un error en el catálogo de Pop Entry/Exit" }
    , WS5013: { text: "Ocurrió un error en el catálogo de Pop Entry/Exit" }
    , JS5013: { text: "Ocurrió un error en el catálogo de Pop Entry/Exit" }
    , CR5013: { text: "Ocurrió un error en el catálogo de Pop Entry/Exit" }
    , UK_PopEntryExit: { text: "Ya existe un registro con el mismo código" }
  }
};



// WEBPACK FOOTER //
// ./src/locales/languages/es_MX/view/operativos/popEntryExit.js